import EventPhotos from "./EventPhotos";
export default EventPhotos;
